import { useContext, useEffect, useState } from "react"
import classNames from "classnames"

import { TLOContext } from "web/contexts"
import useFavourite from "web/hooks/data/useFavourite"

import { StarIcon } from "@heroicons/react/20/solid"
import { StarIcon as OutlineStarIcon } from "@heroicons/react/24/outline"

export default function FavouriteSwitch({ data: dataFromProps }) {
  // get data from TLO context or props (from object list table view)
  const tloContext = useContext(TLOContext)
  const data = dataFromProps || tloContext.data

  const { data: favourite } = useFavourite({
    subjectType: data.resource_type,
    subjectId: data.id,
  })

  // local state to provide immediate visual feedback
  const [isFavourite, setIsFavourite] = useState(data.is_favourite)

  useEffect(() => {
    setIsFavourite(data.is_favourite)
  }, [data.is_favourite])

  async function toggle(e) {
    e.stopPropagation()

    setIsFavourite(!isFavourite)
    isFavourite ? await favourite.destroy() : await favourite.create()
  }

  const Icon = isFavourite ? StarIcon : OutlineStarIcon

  return (
    <Icon
      className={classNames(
        "h-5 w-5 cursor-pointer transition-colors duration-200 hover:text-neutral-1",
        {
          "text-black opacity-50": !isFavourite,
          "text-primary-4": isFavourite,
        }
      )}
      onClick={toggle}
    />
  )
}
